import { Box, Typography, Button, Grid } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import coverImage from 'static/cover.webp';

export const StyledRoot = styled(Box)(({ theme }) => ({
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 3),
    boxSizing: 'border-box',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    backgroundColor: '#1a0505',
    backgroundImage: `linear-gradient(
                        rgba(120, 20, 20, 0.85),
                        rgba(120, 20, 20, 0.85)
                    ), url('${coverImage}')`,
}));

export const StyledInner = styled(Box)({
    'zIndex': 1,
    'textAlign': 'center',
    'maxWidth': 960,
    'width': '100%',
    '& a': {
        'color': 'inherit',
        'textDecoration': 'none',
        '&:hover': {
            borderBottom: '1px solid rgba(255, 255, 255, 0.6)',
        },
    },
});

export const StyledEyebrow = styled(Typography)(({ theme }) => ({
    fontSize: 16,
    letterSpacing: '0.08em',
    color: 'rgba(255,255,255,0.75)',
    fontWeight: 500,
    marginBottom: theme.spacing(2),
}));

export const StyledHeading = styled(Typography)(({ theme }) => ({
    fontSize: 'clamp(36px, 5vw, 60px)',
    fontWeight: 700,
    color: '#fff',
    lineHeight: 1.1,
    marginBottom: theme.spacing(3),
}));

export const StyledBody = styled(Typography)(({ theme }) => ({
    fontSize: 18,
    color: 'rgba(255,255,255,0.9)',
    lineHeight: 1.7,
    maxWidth: 525,
    margin: '0 auto',
    marginBottom: theme.spacing(10),
}));

export const StyledStatsPanel = styled(Grid)(({ theme }) => ({
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 4,
    overflow: 'hidden',
    maxWidth: 800,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(8),
}));

export const StyledStatCell = styled(Grid)(({ theme }) => ({
    'background': 'rgba(0,0,0,0.5)',
    'padding': theme.spacing(3, 2),
    'textAlign': 'center',
    'borderRight': '1px solid rgba(255,255,255,0.3)',
    '&:last-child': {
        borderRight: 'none',
    },
    [theme.breakpoints.down('xs')]: {
        'borderRight': 'none',
        'borderBottom': '1px solid rgba(255,255,255,0.3)',
        '&:last-child': {
            borderBottom: 'none',
        },
    },
}));

export const StyledStatNumber = styled(Typography)(({ theme }) => ({
    fontSize: 'clamp(32px, 4vw, 44px)',
    fontWeight: 700,
    color: '#fff',
    lineHeight: 1,
    marginBottom: theme.spacing(1),
}));

export const StyledStatLabel = styled(Typography)({
    fontSize: 15,
    color: 'rgba(255,255,255,0.85)',
    lineHeight: 1.4,
});

export const StyledCtaButton = styled(Button)(({ theme }) => ({
    'backgroundColor': '#fff',
    'color': '#6b0d0d',
    'fontSize': 16,
    'fontWeight': 600,
    'letterSpacing': '0.08em',
    'padding': theme.spacing(2.5, 6),
    'borderRadius': 4,
    '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.9)',
    },
    [theme.breakpoints.down('xs')]: {
        width: '100%',
    },
}));

export const StyledFooter = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(5),
    borderTop: '1px solid rgba(255,255,255,0.3)',
    maxWidth: 400,
    width: 'inherit',
}));

export const StyledFooterLabel = styled(Typography)(({ theme }) => ({
    fontSize: 13,
    color: 'rgba(255,255,255,0.6)',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
}));

export const StyledFooterPartners = styled(Typography)({
    fontSize: 16,
    color: 'rgba(255,255,255,0.75)',
    lineHeight: 1.8,
});
